export const langHeader = {
  fr: {
    home: 'Home',
    use: 'Utiliser',
    sessions: 'Sessions',
    boards: 'Boards',
    sails: 'Sails & Wings',
    statsG: 'Stats globales',
    statsR: 'Stats utilisation matériel',
    connect: 'Se connecter',
    disconnect: 'Déconnexion',
    modify: 'Mon compte',
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
    cgu: 'CGU',
    license: `Contenu sous licence `,
  },
  eng: {
    home: 'Home',
    use: 'Use',
    sessions: 'Sessions',
    boards: 'Boards',
    sails: 'Sails & Wings',
    statsG: 'Global stats',
    statsR: 'Gear usage stats',
    connect: 'Log in',
    disconnect: 'Log out',
    modify: 'My account',
    registeredOnly: 'Registered users only',
    cgu: 'TOS',
    license: `Content licensed `,
  },
}
